import ServiceBase from "base/baseService"
import { boolToNumber, numberToBool, } from "helper/formater"
import queryString from "query-string"

export default class ClassificacaoTributariaService extends ServiceBase {

    title = "Classificação tributária"
    pluralTitle = "Classificações tributárias"
    url = '/cadastro/fiscal/classificacaotributaria'
    frontUrl = '/cadastro/fiscal/classificacaotributaria'
    frontUrlList = '/cadastro/fiscal/classificacaotributarialist'
    primaryKey = 'codigo_clastrib'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Se usar checkbox (Se permite null?)

        data.exige_trib_clastrib = numberToBool(data.exige_trib_clastrib)
        data.tem_red_bc_cst_clastrib = numberToBool(data.tem_red_bc_cst_clastrib)
        data.tem_red_aliq_clastrib = numberToBool(data.tem_red_aliq_clastrib)
        data.eh_transf_cred_clastrib = numberToBool(data.eh_transf_cred_clastrib)
        data.eh_diferimento_clastrib = numberToBool(data.eh_diferimento_clastrib)
        data.eh_monof_clastrib = numberToBool(data.eh_monof_clastrib)
        data.tem_cred_presum_ibs_zfm_clastrib = numberToBool(data.tem_cred_presum_ibs_zfm_clastrib)
        data.eh_ajuste_compet_clastrib = numberToBool(data.eh_ajuste_compet_clastrib)
        data.eh_trib_regular_clastrib = numberToBool(data.eh_trib_regular_clastrib)
        data.tem_cred_presum_clastrib = numberToBool(data.tem_cred_presum_clastrib)
        data.tem_estorno_cred_clastrib = numberToBool(data.tem_estorno_cred_clastrib)
        data.eh_trib_monof_normal_clastrib = numberToBool(data.eh_trib_monof_normal_clastrib)
        data.eh_trib_monof_suj_reten_clastrib = numberToBool(data.eh_trib_monof_suj_reten_clastrib)
        data.eh_trib_monof_retid_ant_clastrib = numberToBool(data.eh_trib_monof_retid_ant_clastrib)
        data.eh_trib_monof_comb_difer_clastrib = numberToBool(data.eh_trib_monof_comb_difer_clastrib)
        data.para_nfe_clastrib = numberToBool(data.para_nfe_clastrib)
        data.para_nfce_clastrib = numberToBool(data.para_nfce_clastrib)
        data.para_cte_clastrib = numberToBool(data.para_cte_clastrib)
        data.para_cte_os_clastrib = numberToBool(data.para_cte_os_clastrib)
        data.para_bpe_clastrib = numberToBool(data.para_bpe_clastrib)
        data.para_nf3e_clastrib = numberToBool(data.para_nf3e_clastrib)
        data.para_nfcom_clastrib = numberToBool(data.para_nfcom_clastrib)
        data.para_nfse_clastrib = numberToBool(data.para_nfse_clastrib)
        data.para_bpe_tm_clastrib = numberToBool(data.para_bpe_tm_clastrib)
        data.para_bpe_ta_clastrib = numberToBool(data.para_bpe_ta_clastrib)
        data.para_nfag_clastrib = numberToBool(data.para_nfag_clastrib)
        data.para_nfsvia_clastrib = numberToBool(data.para_nfsvia_clastrib)
        data.para_nfabi_clastrib = numberToBool(data.para_nfabi_clastrib)
        data.para_nfgas_clastrib = numberToBool(data.para_nfgas_clastrib)
        data.para_dere_clastrib = numberToBool(data.para_dere_clastrib)

        // Strings notNullable

        data.codigo_clastrib = data?.codigo_clastrib || ''
        data.cod_cstr_clastrib = data?.cod_cstr_clastrib || ''
        data.perc_red_ibs_clastrib = data?.perc_red_ibs_clastrib || ''
        data.perc_red_cbs_clastrib = data?.perc_red_cbs_clastrib || ''

        // Numéricos sem FK

        data.cod_tipali_clastrib = data?.cod_tipali_clastrib || 0
        data.num_anexo_clastrib = data?.num_anexo_clastrib || 0

        return data
    }

    prepareToSave({ data }) {
        return data
    }

    async listByAutoComplete(text) {

        text = (text ?? '').trim()

        if (!text) return

        const search = { page: 1, perPage: 10, type: 'autocomplete' }

        search.codigo_clastrib = `%${text}%`
        search.descricao_clastrib = `%${text}%`

        return await this.list('?' + queryString.stringify(search))
    }

}
